import { memo } from 'react';
import { cn } from '@/lib/utils';
import { NOTIFICATIONS } from '@/lib/constants';

interface NotificationBadgeProps {
  count: number;
  maxDisplay?: number;
  className?: string;
}

/**
 * NotificationBadge - Displays unread notification count
 * Shows "99+" when count exceeds maxDisplay
 * Hidden when count is 0
 */
export const NotificationBadge = memo<NotificationBadgeProps>(
  function NotificationBadge({
    count,
    maxDisplay = NOTIFICATIONS.BADGE_MAX_DISPLAY,
    className,
  }) {
    if (count <= 0) {
      return null;
    }

    const displayCount = count > maxDisplay ? `${maxDisplay}+` : count.toString();
    const ariaLabel = `${count} unread notification${count === 1 ? '' : 's'}`;

    return (
      <span
        className={cn(
          'absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center justify-center',
          // 9px is a sanctioned corner-counter exception (DESIGN.md §Exceptions). Below text-badge (10px).
          'rounded-md bg-destructive px-1 text-[9px] font-semibold text-destructive-foreground',
          'pointer-events-none select-none',
          className
        )}
        aria-label={ariaLabel}
        role="status"
      >
        {displayCount}
      </span>
    );
  }
);
